export default {
  header: {
    title: 'Iberpix',
    subtitle: 'Orthophotos and mapping of the IGN',
    change_language: 'Change language',
    accept: 'Accept',
    help: 'Help',
  },
  visor: {
    coordinates: 'Coordinates',
    zoom_extent: 'Zoom to the map extension',
    share_url: 'Share URL',
    copied: 'Copied',
    accept: 'Accept',
    copy: 'Copy',
    printed: 'Print generated from IBERPIX',
    canary: 'Canary Islands',
    balearic: 'Balearic Islands',
    melilla: 'Melilla',
    ceuta: 'Ceuta',
    peninsula: 'Peninsula',
    map: 'Map',
    image: 'Image',
    street_map: 'Street map',
    hybrid: 'Hybrid',
    lidar: 'LiDAR (Elevation)',
    toponyms: 'Place names',
    corine: 'Land occupation',
    historic: 'Historical Maps',
    info: 'Information',
    close: 'Close',
    welcome: 'Welcome to 5.0 version of Iberpix viewer.',
    help: 'You can check the help in the following <a tabindex="0" tabin href="/iberpix/help" target="_blank" rel="noopener noreferrer">link</a>.',
    old_here: 'If you wish to continue using the <a tabindex="0" href="https://www.ign.es/iberpixhistorico/" target="_blank" rel="noopener noreferrer">previous version</a> of Iberpix, it will be available for a few months.',
    print_info: 'Printing in Iberpix uses external map services and it is possible that depending on the requested resolution, format, loaded maps or higher system usage at this time, it may not be possible. If this happens, please try again later.',
    popup: 'Popup Information'
  },
  tree: {
    search: 'Search',
    type_here: 'Type here...',
    clear: 'Clear',
    please_characters: 'Please enter at least 3 characters to perform a search',
  },
};
